import { getUser, postDataWithToken } from "../api/api";
import {  GETUSERINFO, USERSTATUS } from "../helpers/Constant";


export const setSession = (user) => {
    const currentUser = JSON.parse(localStorage.getItem('user_info'));

    if (user) {
        const updatedUser = { ...currentUser, ...user };

        if (user.token) {
            localStorage.setItem("user_token", user.token.replaceAll('"', ''));
        }
        if (user._id) {
            localStorage.setItem("user_id", user._id);
        }
        if (user.isTrialComplete !== undefined) {
            localStorage.setItem("user_Trial", user.isTrialComplete);
        }
        if (user.language) {
            localStorage.setItem('user_lng', user.language);
        }

        localStorage.setItem('user_info', JSON.stringify(updatedUser));
    } else {
        localStorage.removeItem("user_token");
        localStorage.removeItem("user_type");
        localStorage.removeItem("user_id");
        localStorage.removeItem('user_info');
        localStorage.removeItem('trialData');
        localStorage.removeItem('user_Trial');
        localStorage.removeItem('syncedApp');
        localStorage.removeItem('buddyId');
    }
};


export const getToken = () => {
    return localStorage.getItem("user_token");
};

export const getUserID = () => {
    return localStorage.getItem("user_id");
}

export const getUserType = () => {
    return localStorage.getItem("user_type");
};

export const getUserTrial = () => {
    return localStorage.getItem("user_Trial");
};

export const getUserTrailData = () => {
    return localStorage.getItem("trialData");
};

export const setUserType = (type) => {
    localStorage.setItem("user_type", type);
};

export const getLanguage = () => {
    return localStorage.getItem('user_lng');
};

export const getUserStreak = () => {
    var userInfo = JSON.parse(localStorage.getItem('user_info'));
    return userInfo?.userStreaks?.currentStreak || 1;
};
 
export const getUserInfo = (type) => {
    return JSON.parse(localStorage.getItem("user_info"));
};
export const checkAuth = async () => {
    var value = getToken();
    if(!value){
        setSession(null);
        return null;
    }else{
        const user = await getUser(GETUSERINFO);
        if (user.status !== 200) {
            setSession(null);
            return null;
        } else {
            setSession(user.data);
            return user.data;
        }
    }
};

export const updateStatus = async (status) => {
    await postDataWithToken(USERSTATUS, status);
}

export const formatCompactNumber = (value) => {
    const num = Number(value);
    if (!Number.isFinite(num)) return "0";

    if (Math.abs(num) < 1000) {
        return num.toString();
    }

    if (Math.abs(num) < 1000000) {
        return `${(Math.round((num / 1000) * 10) / 10).toString().replace(/\.0$/, "")}K`;
    }

    if (Math.abs(num) < 1000000000) {
        return `${(Math.round((num / 1000000) * 10) / 10).toString().replace(/\.0$/, "")}K`;
    }

    return `${(Math.round((num / 1000000000) * 10) / 10).toString().replace(/\.0$/, "")}K`;
};
export const onBlur = () => {
    window.location.href = `uniwebview://keyboardClose`;
};

export const onFocus = () => {
    window.location.href = `uniwebview://keyboardOpen`;
};

const isKeyboardSupportedElement = (element) => {
    if (!element) return false;
    const tagName = element.tagName?.toLowerCase();
    return (
        tagName === "input" ||
        tagName === "textarea" ||
        element.isContentEditable === true
    );
};

export const attachGlobalKeyboardHandlers = () => {
    const handleFocusIn = (event) => {
        if (isKeyboardSupportedElement(event.target)) {
            onFocus();
        }
    };

    const handleFocusOut = (event) => {
        if (isKeyboardSupportedElement(event.target)) {
            onBlur();
        }
    };

    document.addEventListener("focusin", handleFocusIn);
    document.addEventListener("focusout", handleFocusOut);

    return () => {
        document.removeEventListener("focusin", handleFocusIn);
        document.removeEventListener("focusout", handleFocusOut);
    };
};